var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SystemProgram, Transaction } from "@solana/web3.js";
import { TradeStatus } from "../../utils/types";
import { getProgram } from "../../utils/getProgram.obj";
import { getSwapIdentityFromData } from "../../utils/getSwapIdentityFromData.function";
import { getSwapDataAccountFromPublicKey } from "../../utils/getSwapDataAccountFromPublicKey.function";
import { SOLANA_SPL_ATA_PROGRAM_ID } from "../../utils/const";
export var createValidateClaimedInstructions = function (Data) { return __awaiter(void 0, void 0, void 0, function () {
    var program, swapData, swapIdentity, _a, _b;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                program = Data.program ? Data.program : getProgram({ clusterOrUrl: Data.clusterOrUrl });
                return [4 /*yield*/, getSwapDataAccountFromPublicKey({
                        program: program,
                        swapDataAccount_publicKey: Data.swapDataAccount,
                    })];
            case 1:
                swapData = _d.sent();
                // console.log("swapData", swapData);
                if (!swapData) {
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: "Swap initialization in progress or not initialized. Please try again later.",
                    };
                }
                else if (!(swapData.status === TradeStatus.WaitingToDeposit ||
                    swapData.status === TradeStatus.WaitingToClaim)) {
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: "Swap is't in the adequate status for Validating Claiming.",
                        swapStatus: swapData.status,
                    };
                    // } else if (Data.signer.equals(swapData.initializer)) {
                } //else if (!Data.signer.equals(swapData.initializer) && Data.skipFinalize) return undefined;
                swapIdentity = getSwapIdentityFromData({
                    swapData: swapData,
                    clusterOrUrl: Data.clusterOrUrl,
                });
                _c = {};
                _b = (_a = new Transaction()).add;
                return [4 /*yield*/, program.methods
                        .validateClaimed(swapIdentity.swapDataAccount_seed)
                        .accounts({
                        systemProgram: SystemProgram.programId,
                        splTokenProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        swapDataAccount: Data.swapDataAccount,
                        signer: Data.signer,
                    })
                        .instruction()];
            case 2: return [2 /*return*/, [
                    (_c.tx = _b.apply(_a, [_d.sent()]),
                        _c)
                ]];
        }
    });
}); };
